import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTenant } from '../../../context/TenantContext';
import { warmInlineEm } from './warmInlineEm';

const DEFAULTS = {
  headline: 'There’s a seat *for you*.',
  body:
    'Spring cohorts open Monday. No commitment to start — browse a course, sit in on an intro session, see how it feels.',
  buttonText: 'Browse spring programmes',
};

export const WarmCTASection: React.FC = () => {
  const { tenant } = useTenant();
  const cta = tenant?.branding.marketing?.cta ?? {};
  const headline = cta.headline || DEFAULTS.headline;
  const body = cta.body || DEFAULTS.body;
  const buttonText = cta.buttonText || DEFAULTS.buttonText;
  const eyebrow = cta.eyebrow?.trim() || 'Come find us';

  return (
    <section id="cta" className="warm-closer relative overflow-hidden py-24 md:py-32 text-center">
      <span className="absolute -top-32 -left-24 w-[520px] h-[520px] rounded-full bg-[var(--warm-accent-soft)] blur-3xl opacity-60 pointer-events-none" />
      <span className="absolute -bottom-32 -right-24 w-[460px] h-[460px] rounded-full bg-[var(--warm-sage-soft)] blur-3xl opacity-70 pointer-events-none" />

      <div className="relative max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="font-warm-hand text-2xl text-[var(--warm-accent-deep)] mb-3 inline-block -rotate-1">
          {eyebrow}
        </div>
        <h2 className="font-warm-serif text-4xl md:text-6xl lg:text-[76px] leading-[1.0] tracking-[-0.025em] text-[var(--warm-ink)] mb-6 text-balance">
          {warmInlineEm(headline)}
        </h2>
        <p className="text-lg md:text-xl text-[var(--warm-ink-soft)] mb-9 leading-relaxed max-w-[44ch] mx-auto">
          {body}
        </p>
        <Link
          to="/courses"
          className="warm-btn-primary group inline-flex items-center gap-3 px-7 py-4 text-base font-bold rounded-full"
        >
          {buttonText}
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </section>
  );
};
